export * from './core.module';



// WEBPACK FOOTER //
// /home/runner/work/power-planner/power-planner/src/app/core.module/index.ts